import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import AdminMenuWrapper from '@admin/nav_menu/AdminMenuWrapper';
import { Switcher, BasicButton, BasicText } from '@components';
import LoadingWrapper from '@components/LoadingWrapper';
import { getAPIRequest } from '@actions';
import styles from './ReportHome.module.css';
import { Input, Space } from 'antd';
import ReportedItem from '@reports/ReportedItem';

const MOST_RECENT = "Most Recently Reported";
const MOST_FREQUENT = "Most Frequenlty Reported";

const ReportHome = ({
  getAPIRequest
}) => {
  const [reportedData, setReportedData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isViewingRecent, setIsViewingRecent] = useState(true);

  console.log("data", reportedData);

  useEffect(() => {
    console.log("HEELO");
    getAPIRequest(
      '/admin/get_reported_data',
      {},
      response => {
        setIsLoading(false);
        setReportedData(response.reported_data);
      },
      error => {
        //onFail(error.error);
        console.log(error);
      },
    )
  }, []);

  const reportsList = () => {
    if (isViewingRecent) {
      return reportedData.most_recent.map((report) => {
        console.log(report);
        return <ReportedItem key={report.id} reportItem={report} />;
      });
    } else {
      return reportedData.most_reported.map((report) => {
        return <ReportedItem key={report.id} reportItem={report} />;
      });
    }
  }


  return (
    <AdminMenuWrapper>
      <LoadingWrapper isLoading={isLoading} loadingText="Fetching Report Data" size="large">
        <div className={styles.report_container_style}>
          <Switcher
            options={[MOST_RECENT, MOST_FREQUENT]}
            onSelectOption={(option) => {
              setIsViewingRecent(option === MOST_RECENT);
            }}
            selectedOption={isViewingRecent ? MOST_RECENT : MOST_FREQUENT}
          />

          {reportedData != null &&
            <div className={styles.list_container}>
              {reportsList()}
            </div>
          }
        </div>
      </LoadingWrapper>
    </AdminMenuWrapper>
  );
};



export default connect(null, {
  getAPIRequest
})(ReportHome);
